import { Component, OnInit, Input } from '@angular/core';

import { TranslateService } from 'ng2-translate';
import { ProjectsService } from '../../services/projects.service';

import { WorkConstants } from "../../work.const";

@Component({
  selector: 'app-time-line',
  templateUrl: './time-line.component.html'
})
export class TimeLineComponent implements OnInit {

  @Input() projectId: number;
  timeLine: any;

  workConstants:any = WorkConstants;

  constructor(
    private translate: TranslateService,
    private projectsService: ProjectsService
  ) { }

  ngOnInit() {
  }

  showTimeLine() {
    this.getTimeLine();
  }

  private getTimeLine() {
    this.projectsService.getTimeLine(this.projectId).subscribe(
      timeLine => {
        this.timeLine = timeLine.data;
      }
    );
  }

}


// WEBPACK FOOTER //
// ./src/app/modules/work/modal/time-line/time-line.component.ts